import { useCallback } from "react";

import type { DiagnosticsTab } from "./DiagnosticsSettings.types";

/**
 * Recheck acts on the target in view and nothing else. Each target class is
 * read a different way — the server over HTTP plus the trace RPC, a sprite
 * through CMMD — so one button cannot mean one call.
 */
export function useDiagnosticsRefresh(input: {
  readonly activeTab: DiagnosticsTab;
  readonly canRefreshCurrentRuntime: boolean;
  readonly isPlatformAdmin: boolean;
  readonly recheckCloudRuntime: () => void;
  readonly refreshCurrentRuntime: () => Promise<unknown>;
  readonly refreshLocalServer: () => void;
  readonly refreshCloudTraces: () => void;
  readonly refreshCloudInventory: () => void;
}) {
  return useCallback(() => {
    if (input.activeTab === "server") {
      if (input.isPlatformAdmin) input.refreshLocalServer();
      return;
    }
    if (input.activeTab !== "cloud") return;
    if (input.canRefreshCurrentRuntime) {
      void input.refreshCurrentRuntime();
    }
    if (!input.isPlatformAdmin) return;
    input.refreshCloudInventory();
    input.refreshCloudTraces();
    input.recheckCloudRuntime();
  }, [input]);
}
